import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { ProjectAnalysisSummary } from '../../../entities/analysis';

ChartJS.register(ArcElement, Tooltip, Legend);

interface IssueDistributionChartProps {
    summary?: ProjectAnalysisSummary;
    stats?: {
        critical: number;
        high: number;
        medium: number;
        low: number;
    };
}

export function IssueDistributionChart({ summary, stats }: IssueDistributionChartProps) {
    const data = {
        labels: ['Critical', 'High', 'Medium', 'Low'],
        datasets: [
            {
                data: [
                    stats?.critical || (summary?.issues_by_severity?.critical ?? 0),
                    stats?.high || (summary?.issues_by_severity?.high ?? 0),
                    stats?.medium || (summary?.issues_by_severity?.medium ?? 0),
                    stats?.low || (summary?.issues_by_severity?.low ?? 0),
                ],
                backgroundColor: [
                    'rgba(239, 68, 68, 0.8)', // critical
                    'rgba(249, 115, 22, 0.8)', // high
                    'rgba(234, 179, 8, 0.8)',  // medium
                    'rgba(59, 130, 246, 0.8)', // low
                ],
                borderColor: [
                    'rgb(239, 68, 68)',
                    'rgb(249, 115, 22)',
                    'rgb(234, 179, 8)',
                    'rgb(59, 130, 246)',
                ],
                borderWidth: 1,
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'right' as const,
                labels: {
                    font: {
                        family: 'monospace',
                        size: 10
                    },
                    color: 'rgb(156, 163, 175)'
                }
            },
        },
        cutout: '70%',
    };

    return <Doughnut data={data} options={options} />;
}
